import gql from 'graphql-tag';

import thumbnailInfoFragment from '../fragments/thumbnailInfoFragment';

export const queryIntegrationEmailThumbnailInfo = gql`
  query integrationEmailThumbnailInfo(
    $integrationID: DokkioID!
    $remoteID: ID!
    $maxWidth: Int
    $maxHeight: Int
  ) {
    integrationEmailThumbnailInfo(
      integrationID: $integrationID
      remoteID: $remoteID
      maxWidth: $maxWidth
      maxHeight: $maxHeight
    ) {
      ...thumbnailInfoFragment
    }
  }
  ${thumbnailInfoFragment}
`;

export default queryIntegrationEmailThumbnailInfo;
